import axios from 'axios'
import Message from 'iview'
// 深拷贝
export function deepClone(original) {
  return JSON.parse(JSON.stringify(original))
}

// 时间戳转日期字符串
export function stampToStr(stamp) {
  if (stamp === undefined || stamp === null || stamp === '' || stamp.toString().length !== 13) {
    return ''
  }
  const tmp = (new Date(stamp)).toJSON().replace(/T/g, ' ').split('.')[0]
  return tmp
}
export function dateObjToStr(obj) {
  if (typeof obj === 'object') {
    const year = obj.getFullYear()
    const month = formatTime(obj.getMonth() + 1)
    const date = formatTime(obj.getDate())
    const hours = formatTime(obj.getHours())
    const minutes = formatTime(obj.getMinutes())
    const seconds = formatTime(obj.getSeconds())

    return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds
  } else {
    return ''
  }
}
function formatTime(v) {
  return (v < 10) ? '0' + v : v
}

export function dateObjToStr2(obj) {
  if (typeof obj === 'object') {
    const year = obj.getFullYear()
    const month = formatTime(obj.getMonth() + 1)
    const date = formatTime(obj.getDate())
    return year + '-' + month + '-' + date
  } else {
    return ''
  }
}
// 构造n长的元素为item的相同数组 [1,1,1,1,1] 这种
export function getRepeatArray(n, item) {
  return Array.apply(null, Array(n)).map((i) => (deepClone(item)))
}

export function dateToStr(obj) { // 封 19-06-05
  if (!obj) {
    return
  }
  var year = obj.getFullYear(),
    month = obj.getMonth() + 1 > 9 ? obj.getMonth() + 1 : '0' + (obj.getMonth() + 1),
    date = obj.getDate() > 9 ? obj.getDate() : '0' + obj.getDate(),
    hour = obj.getHours() > 9 ? obj.getHours() : '0' + obj.getHours(),
    minute = obj.getMinutes() > 9 ? obj.getMinutes() : '0' + obj.getMinutes(),
    second = obj.getSeconds() > 9 ? obj.getSeconds() : '0' + obj.getSeconds()
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second
}

// 封装传参
export function addQuery(query, name, value) {
  if (value !== undefined && value !== '') {
    query[name] = value
  }
  return query
}

// 处理不同数字标记的状态文字
// 输入 v => 0
// 输入 arr => ['需要', '不需要']
// 输出 需要
export function formatText(v, arr, okText = '已付款', warnText = '') {
  if (v === undefined || v === null || v === '') {
    return ''
  } else {
    const index = v.toString()
    if (arr[index] === okText) {
      return '<span style="color: #2BB968">' + arr[index] + '</span>'
    } else if (arr[index] === warnText) {
      return '<span style="color: #DFA338">' + arr[index] + '</span>'
    } else {
      return arr[index]
    }
  }
}
export function formatTitle(v) {
  if (v === undefined || v === null || v === '') {
    return ''
  } else {
    return '<span title="' + v + '">' + v + '</span>'
  }
}
// 前端处理序号
export function formatIndex(index, pageIndex, pageSize) {
  return (pageIndex - 1) * pageSize + (index + 1)
}
export function addTitle(title) { // span增加title
  if (title === undefined || title === null || title === '') {
    return ''
  } else {
    return `<span title=${title}>${title}</span>`
  }
}
export function downloadTable(url, params) {
  if (!url) return false
  axios.get(process.env.VUE_APP_BASE_API + url, {
    params: params,
    crossDomain: true,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'YJHTOKEN': localStorage.getItem('token')
    },
    responseType: 'blob'
  }).then(res => {
    if (res.status !== 200) {
      Message.info('导出数据失败!')
      return false
    }
    const string = res.headers['content-disposition']
    const demoName = string.split(';').pop().slice(18)
    var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = decodeURI(demoName)
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(href)
  })
}

